import { render, staticRenderFns } from "./PdfZoomViewer.vue?vue&type=template&id=9dd96df4&scoped=true"
import script from "./PdfZoomViewer.vue?vue&type=script&lang=js"
export * from "./PdfZoomViewer.vue?vue&type=script&lang=js"
import style0 from "./PdfZoomViewer.vue?vue&type=style&index=0&id=9dd96df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd96df4",
  null
  
)

export default component.exports